import { z, type ZodType } from 'zod';

import {
  MaskedCompleteAddressWithPhoneNumberSchema,
  AddressWithPhoneNumberSchema
} from '../../Address';
import { ReturnItemSchema } from './item/schemas';
import ReturnOrderType from './ReturnOrderType';
import ReturnShippingMethod from './ReturnShippingMethod';
import type { IReturnOrder } from '.';

export const ReturnOrderSchema = z.object({
  originalOrderID: z.string(),
  orderID: z.string(),
  customerEmail: z.string().email(),
  orderPlacedDate: z.string().datetime().or(z.string().date()),
  type: z.nativeEnum(ReturnOrderType),
  returnItems: z.array(ReturnItemSchema),
  /**
   * We use an union type since the address could be masked or not depending
   * if the user has logged-in already.
   */
  shippingAddress: z.union([
    AddressWithPhoneNumberSchema,
    MaskedCompleteAddressWithPhoneNumberSchema
  ]),
  returnShippingMethod: z.nativeEnum(ReturnShippingMethod)
}) satisfies ZodType<IReturnOrder>;

export const CreateLabelReturnOrderSchema = ReturnOrderSchema.omit({
  // Not needed when creating a label, since this is defined in another parameter.
  returnShippingMethod: true,

  // Not needed when creating a label since the return is linked to an existing order only and the return orderID is not there yet.
  orderID: true
}).extend({
  // We avoid using `email` validation here since in some cases the email may be masked.
  customerEmail: z.string()
});
